/* eslint-disable @typescript-eslint/naming-convention */
// src/hooks/useHasUnpaidSubscription.ts
import useAuth from "src/hooks/useAuth";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";

const useSubscriptionCondition = () => {
  const { isAuthenticated } = useAuth() as any;
  const { stripe_subscription_status, plans } = useActiveUserDetail();

  // No active plan in DB
  const noPlan =
    plans === null || plans === "null" || typeof plans === "undefined";

  // Payment failed permanently (Stripe marked as unpaid)
  const isPaymentFailed = stripe_subscription_status === "unpaid";

  // Payment retries ongoing (Stripe marked as past_due)
  const isPaymentDue = stripe_subscription_status === "past_due";

  // Subscription cancelled and user has no fallback plan
  const isSubscriptionCancelled =
    stripe_subscription_status === "canceled" && noPlan;

  // Combined condition: user is logged in but has a subscription issue
  const hasSubscriptionIssue =
    isPaymentFailed || isPaymentDue || isSubscriptionCancelled || noPlan;

  return isAuthenticated && hasSubscriptionIssue;
};

export default useSubscriptionCondition;
